module.exports = __webpack_public_path__ + "static/media/Chiller_Plant-2.988e080c.png";